import { render, staticRenderFns } from "./waiting-payment.vue?vue&type=template&id=36f44a8a&scoped=true"
import script from "./waiting-payment.vue?vue&type=script&lang=js"
export * from "./waiting-payment.vue?vue&type=script&lang=js"
import style0 from "./waiting-payment.vue?vue&type=style&index=0&id=36f44a8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f44a8a",
  null
  
)

export default component.exports